module.exports = __webpack_public_path__ + "img/idea.f51effaf.svg";